module.exports = __webpack_public_path__ + "static/img/7.8391eb18.jpg";